import { createReducer } from 'typesafe-actions';
import {
  type AssetPickerActions,
  closeAssetPicker,
  openAssetPicker,
  toggleAssetPickerSortMenuOpen
} from './actions.js';
import type { NAME } from './constants.js';

export type AssetPickerState = {
  sortMenuOpen: boolean;
  isOpen: boolean;
};

export type AssetPickerSlice = {
  [NAME]: AssetPickerState;
};

export const initialAssetPickerState: AssetPickerState = {
  sortMenuOpen: false,
  isOpen: false
};

export default createReducer<AssetPickerState, AssetPickerActions>(initialAssetPickerState)
  .handleAction(toggleAssetPickerSortMenuOpen, (state) => ({
    ...state,
    sortMenuOpen: !state.sortMenuOpen
  }))
  .handleAction(openAssetPicker, (state) => ({ ...state, isOpen: true }))
  .handleAction(closeAssetPicker, (state) => ({ ...state, isOpen: false }));
